<template>
  <div class="aboutus-page">
    <main class="main-content">
      <section class="aboutus-hero">
        <div class="hero-overlay">
          <div class="hero-content">
            <h1 v-for="(title, index) in defaultInfos.about_title" :key="index">
              {{ title }}
            </h1>
            <p
              v-for="(subtitle, index) in defaultInfos.about_subtitle"
              :key="index"
            >
              {{ subtitle }}
            </p>
          </div>
        </div>
      </section>

      <section class="aboutus-content-section">
        <div class="container">
          <div class="aboutus-content">
            <div class="aboutus-text">
              <h2>医院历史</h2>
              <p
                v-for="(history, index) in defaultInfos.about_history"
                :key="index"
              >
                {{ history }}
              </p>
              <div class="aboutus-image">
                <Carousel />
              </div>

              <h2
                v-for="(item, index) in defaultInfos.about_header1"
                :key="index"
              >
                {{ item }}
              </h2>
              <p
                v-for="(item, index) in defaultInfos.about_header1_subtitle"
                :key="index"
              >
                {{ item }}
              </p>

              <h2
                v-for="(item, index) in defaultInfos.about_header2"
                :key="index"
              >
                {{ item }}
              </h2>
              <ul>
                <template
                  v-for="item in defaultInfos.about_header2_subtitle"
                  :key="item.title"
                >
                  <li>
                    <strong>{{ item.split("|*|")[0] }}</strong>
                    {{ item.split("|*|")[1] }}
                  </li>
                </template>
              </ul>

              <h2
                v-for="(item, index) in defaultInfos.about_header3"
                :key="index"
              >
                {{ item }}
              </h2>
              <div class="stats-grid">
                <template
                  v-for="item in defaultInfos.about_header3_subtitle"
                  :key="item.label"
                >
                  <div class="stat-item">
                    <div class="stat-number">{{ item.split("|*|")[0] }}</div>
                    <div class="stat-label">{{ item.split("|*|")[1] }}</div>
                  </div>
                </template>
              </div>

              <h2>联系我们</h2>
              <p
                v-for="(item, index) in defaultInfos.about_contact"
                :key="index"
              >
                {{ item }}
              </p>
              <div class="contact-details">
                <p
                  v-for="(item, index) in defaultInfos.about_contact_info"
                  :key="index"
                >
                  <strong>{{ item.split("|*|")[0] }}</strong
                  >{{ item.split("|*|")[1] }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script setup lang="ts">
import Carousel from "@/components/Carousel/index.vue";

import { computed } from "vue";
import { useDefaultInfoStore } from "@/stores/defaultInfo.ts";
const defaultInfoStore = useDefaultInfoStore();
const defaultInfos = computed(() => defaultInfoStore.getFormateInfo);
</script>
<style scoped>
@import "./index.css";
</style>
